export default __webpack_public_path__ + "static/media/surgery-room.30f2bd06.png";